var Backbone = require('backbone');

/**
 * If/When add different search types, this will likely need to change and be refined.
 * Maybe these each need a corresponding TextSearcher ... see if/when have options ...
 */



module.exports = Backbone.Model.extend({

   defaults: {

        areaType: 'word', // word, line, or zone -- now only does word

        // only one now -- searches consecutive words, ignoring certain characters
        // -- maybe we need more fine grained control -- eg google would cover all things below .. would have to break out ..

        type: 'google', // searches Consecutive Words; Firefox: a phrase search

        // TODO: search a search type options -- may be different for different search types
        ignoreCase: true,
        ignoreCertainCharacters: true

        // whole words ? -- what else ... (see MS Word -- they have clear options)
    },


    /**
     * Characters to ignore when searching text in the words.
     * For now just do selected punctuation: documented here:
     * http://docs.feith.com/pages/editpage.action?pageId=66521034 for document
     * Later this may be a property
     * Maybe we later generate from a list
     * Do we want to only allow all alphanumeric ?? -- downside is you can't search for them.
     * Note: if used in a RegExp constructor -- we need to escape the string see code in 'textSearcher'.
     * - eg var ignoreCharacterPattern = '\\.';
     *     var ignoreCharacterRegExp = new RegExp( ignoreCharacterPattern , 'g');
     * Alternative would be creating with double escape's in a string -- which is very hard to understand.
     * Now coded here as a literal, instead of being built up, which could be the case if we later put more
     * options on the characters to ignore ( currently hardcoded ).
     **/
    getCharactersToIgnoreReg: function() {

        return /[\.\?!,:;\"\'\(\)\[\]\{\}\/\\-]/g;

    }



});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/models/SearchOptions.js
 ** module id = 583
 ** module chunks = 0
 **/